<!--<div (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)" id="main-menu"
     class="main-menu menu-fixed menu-dark menu-accordion menu-shadow" data-scroll-to-active="true">
  <div id="main-menu-content" class="main-menu-content ps-container ps-theme-light" fxFlex="auto"
       [perfectScrollbar]="config">
    <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">-->
<!-- Menu -->
<!--{{child?child.title:''}}-->
<!--_menuSettingsConfig.vertical_menu.items , custommenu-->
<!--<li *ngFor="let child of custommenu" class="" [ngClass]="{
    'has-sub' : child.submenu,
    'nav-item' : child.title,
    'navigation-header' :child.section,
    'open' : child.isOpen && child.submenu,
    'active': child.isSelected && !child.submenu,
    'menu-collapsed-open': child.isSelected && child.submenu,
    'hover': child.hover
    }">-->
<!-- (click)="select('main', child.section)" 'active': isActive('main', child.section),'active': child.isSelected && !child.submenu,-->
<!-- Section -->
<!--<span class="menu-title" *ngIf="child.section">{{child.section}}</span>
<i class="la" *ngIf="child.section" [ngClass]="child.icon" data-toggle="tooltip" data-placement="right"
   data-original-title="Support"></i>-->
<!--<ul style="display:none;">-->
<!--<li class="nav-item" *ngFor="let subchild of child.submenu" [ngClass]="{active: isActive('sub', subchild.title)}" (click)="select('sub', subchild.title, $event);">-->
<!--<i class="la" [ngClass]="child.icon"></i>-->
<!--<span class="menu-title" data-i18n="">{{child.title}}</span>-->
<!--<a *ngIf="child.title && !child.submenu && !child.excludeInVertical && !child.isExternalLink && !child.issupportExternalLink && !child.isStarterkitExternalLink"
   routerLink="{{child.page !== 'null'?child.page:router.url}}" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>
<a *ngIf="child.title && !child.submenu && !child.excludeInVertical && child.isExternalLink"
   [href]="child.page" target="_blank" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>
<a *ngIf="child.title && !child.submenu && !child.excludeInVertical && child.isStarterkitExternalLink"
   [href]="child.page" target="_blank" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>-->
<!-- Submenu -->
<!--<a *ngIf="child.title && child.submenu && !child.excludeInVertical"
   routerLink="{{child.page !== 'null'?child.page:router.url}}" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>-->
<!--</li>-->
<!--</ul>-->
<!-- Root Menu -->
<!--<ul *ngIf="child.submenu" class="menu-content" [@popOverState]="child.isOpen">-->
<!-- Submenu of Submenu -->
<!--<li *ngFor="let subchild of child.submenu.items" class="isShown"
              [ngClass]="{'has-sub':(subchild.submenu),'active': subchild.isSelected && !subchild.submenu, 'open': subchild.isOpen && subchild.submenu}">
            <a class="menu-item" *ngIf="!subchild.submenu && !subchild.excludeInVertical" (click)="toggleMenu($event, subchild, true)"
               routerLink="{{subchild.page !== 'null'?subchild.page:router.url}}">{{subchild.title}}</a>
            <a class="menu-item" *ngIf="subchild.submenu && !subchild.excludeInVertical" (click)="toggleMenu($event, subchild, true)"
               routerLink="{{subchild.page !== 'null'?subchild.page:router.url}}">{{subchild.title}}</a>
            <ul *ngIf="subchild.submenu && !subchild.excludeInVertical" class="menu-content">
              <li *ngFor="let subchild of subchild.submenu.items" [ngClass]="{'active': subchild.isSelected && !subchild.submenu}">
                <a class="menu-item" *ngIf="!subchild.event"
                   routerLink="{{subchild.page}}" (click)="toggleMenu($event, subchild, true)">{{subchild.title}}</a>
                <a class="menu-item" *ngIf="subchild.event"
                   (click)="callFunction(subchild.event, subchild)">{{subchild.title}}</a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>-->
<!--<aside class="sidebar" [class.open]="isOpen">
  <div class="sidebar-brand">
    <div class="brand-logo">🏨</div>
    <div>
      <div class="brand-name">Om Hotel Sarvana</div>
      <div class="brand-sub">Bhavan &nbsp;·&nbsp; Billing Suite</div>
    </div>
  </div>

  <nav class="sidebar-nav">
    <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
      -->
<!-- Menu -->
<!--{{child?child.title:''}}-->
<!--_menuSettingsConfig.vertical_menu.items , custommenu-->
<!--<li *ngFor="let child of custommenu" class="" [ngClass]="{
  'has-sub' : child.submenu,
  'nav-item' : child.title,
  'navigation-header' :child.section,
  'open' : child.isOpen && child.submenu,
  'active': child.isSelected && !child.submenu,
  'menu-collapsed-open': child.isSelected && child.submenu,
  'hover': child.hover
  }">
  <span class="menu-title" *ngIf="child.section">{{child.section}}</span>
  <i class="la" *ngIf="child.section" [ngClass]="child.icon" data-toggle="tooltip" data-placement="right"
     data-original-title="Support"></i>-->
<!--<ul style="display:none;">-->
<!--<li class="nav-item" *ngFor="let subchild of child.submenu" [ngClass]="{active: isActive('sub', subchild.title)}" (click)="select('sub', subchild.title, $event);">-->
<!--<i class="la" [ngClass]="child.icon"></i>-->
<!--<span class="menu-title" data-i18n="">{{child.title}}</span>-->
<!--<a *ngIf="child.title && !child.submenu && !child.excludeInVertical && !child.isExternalLink && !child.issupportExternalLink && !child.isStarterkitExternalLink"
   routerLink="{{child.page !== 'null'?child.page:router.url}}" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>
<a *ngIf="child.title && !child.submenu && !child.excludeInVertical && child.isExternalLink"
   [href]="child.page" target="_blank" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>
<a *ngIf="child.title && !child.submenu && !child.excludeInVertical && child.isStarterkitExternalLink"
   [href]="child.page" target="_blank" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>-->
<!-- Submenu -->
<!--<a *ngIf="child.title && child.submenu && !child.excludeInVertical"
   routerLink="{{child.page !== 'null'?child.page:router.url}}" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>-->
<!--</li>-->
<!--</ul>-->
<!-- Root Menu -->
<!--<ul *ngIf="child.submenu" class="menu-content" [@popOverState]="child.isOpen">-->
<!-- Submenu of Submenu -->
<!--<li *ngFor="let subchild of child.submenu.items" class="isShown"
        [ngClass]="{'has-sub':(subchild.submenu),'active': subchild.isSelected && !subchild.submenu, 'open': subchild.isOpen && subchild.submenu}">
      <a class="menu-item" *ngIf="!subchild.submenu && !subchild.excludeInVertical" (click)="toggleMenu($event, subchild, true)"
         routerLink="{{subchild.page !== 'null'?subchild.page:router.url}}">{{subchild.title}}</a>
      <a class="menu-item" *ngIf="subchild.submenu && !subchild.excludeInVertical" (click)="toggleMenu($event, subchild, true)"
         routerLink="{{subchild.page !== 'null'?subchild.page:router.url}}">{{subchild.title}}</a>
      <ul *ngIf="subchild.submenu && !subchild.excludeInVertical" class="menu-content">
        <li *ngFor="let subchild of subchild.submenu.items" [ngClass]="{'active': subchild.isSelected && !subchild.submenu}">
          <a class="menu-item" *ngIf="!subchild.event"
             routerLink="{{subchild.page}}" (click)="toggleMenu($event, subchild, true)">{{subchild.title}}</a>
          <a class="menu-item" *ngIf="subchild.event"
             (click)="callFunction(subchild.event, subchild)">{{subchild.title}}</a>
        </li>
      </ul>
    </li>
  </ul>

</li>
</ul>-->
<!--<div class="nav-section-label">Main</div>
<a class="nav-item" [class.active]="activeRoute === 'dashboard'" (click)="navigate('dashboard')">
  <span class="nav-icon">⊞</span> Dashboard
</a>

<div class="nav-section-label">Account & Management</div>
<a class="nav-item" [class.active]="activeRoute === 'account'" (click)="navigate('account')">
  <span class="nav-icon">👤</span> Account Creation
</a>

<div class="nav-section-label">Registration</div>
<a class="nav-item" [class.active]="activeRoute === 'manager'" (click)="navigate('manager')">
  <span class="nav-icon">🛡️</span> Manager
</a>
<a class="nav-item" [class.active]="activeRoute === 'supervisor'" (click)="navigate('supervisor')">
  <span class="nav-icon">👁️</span> SuperVisor
</a>
<a class="nav-item" [class.active]="activeRoute === 'supplier'" (click)="navigate('supplier')">
  <span class="nav-icon">🚚</span> Supplier
</a>

<div class="nav-section-label">Customer Management</div>
<a class="nav-item" [class.active]="activeRoute === 'customer'" (click)="navigate('customer')">
  <span class="nav-icon">🧑‍🤝‍🧑</span> Customer
</a>

<div class="nav-section-label">Attendance</div>
<a class="nav-item" [class.active]="activeRoute === 'managerattendance'" (click)="navigate('managerattendance')">
  <span class="nav-icon">📋</span> Manager Report
</a>
<a class="nav-item" [class.active]="activeRoute === 'supervisorattendance'" (click)="navigate('supervisorattendance')">
  <span class="nav-icon">📋</span> Supervisor Report
</a>
<a class="nav-item" [class.active]="activeRoute === 'supplierattendance'" (click)="navigate('supplierattendance')">
  <span class="nav-icon">📋</span> Supplier Report
</a>
<a class="nav-item" [class.active]="activeRoute === 'attendancereport'" (click)="navigate('attendancereport')">
  <span class="nav-icon">📋</span> Attendance Report
  <span class="nav-badge">3</span>
</a>-->
<!--</nav>
</aside>-->
<!--<aside class="sidebar" [class.open]="isOpen">
  <div class="sidebar-brand">
    <div class="brand-logo">🏨</div>
    <div>
      <div class="brand-name">Om Hotel Sarvana</div>
      <div class="brand-sub">Bhavan &nbsp;·&nbsp; Billing Suite</div>
    </div>
  </div>

  <nav class="sidebar-nav">
    <ul #mainMenuNavigation
        class="navigation navigation-main"
        id="main-menu-navigation"
        data-menu="menu-navigation">
      <li *ngFor="let child of custommenu; trackBy: trackByMenu"
          [ngClass]="{
          'has-sub': child.submenu,
          'nav-item': child.title,
          'navigation-header': child.section,
          'open': child.isOpen && child.submenu,
          'active': child.isSelected && !child.submenu,
          'menu-collapsed-open': child.isSelected && child.submenu,
          'hover': child.hover
        }">
        <span class="menu-title" *ngIf="child.section">{{ child.section }}</span>
        <i class="la"
           *ngIf="child.section"
           [ngClass]="child.icon"
           data-toggle="tooltip"
           data-placement="right"
           [attr.data-original-title]="child.section"></i>

        <a *ngIf="child.title && !child.submenu && !child.excludeInVertical && !child.isExternalLink && !child.issupportExternalLink && !child.isStarterkitExternalLink"
           [routerLink]="child.page !== 'null' ? child.page : router.url"
           (click)="toggleMenu($event, child)">
          <i class="la" [ngClass]="child.icon"></i>
          <span class="menu-title" data-i18n="">{{ child.title }}</span>
          <span *ngIf="child.badge"
                class="badge badge-pill float-right"
                [ngClass]="{
              'badge-info mr-2': child.badge.type === 'badge-info',
              'badge-danger': child.badge.type === 'badge-danger'
            }">
            {{ child.badge.value }}
          </span>
        </a>

        <a *ngIf="child.title && !child.submenu && !child.excludeInVertical && child.isExternalLink"
           [href]="child.page"
           target="_blank"
           rel="noopener"
           (click)="toggleMenu($event, child)">
          <i class="la" [ngClass]="child.icon"></i>
          <span class="menu-title" data-i18n="">{{ child.title }}</span>
        </a>

        <a *ngIf="child.title && !child.submenu && !child.excludeInVertical && child.isStarterkitExternalLink"
           [href]="child.page"
           target="_blank"
           rel="noopener"
           (click)="toggleMenu($event, child)">
          <i class="la" [ngClass]="child.icon"></i>
          <span class="menu-title" data-i18n="">{{ child.title }}</span>
        </a>

        <a *ngIf="child.title && child.submenu && !child.excludeInVertical"
           [routerLink]="child.page !== 'null' ? child.page : router.url"
           (click)="toggleMenu($event, child)">
          <i class="la" [ngClass]="child.icon"></i>
          <span class="menu-title" data-i18n="">{{ child.title }}</span>
          <span *ngIf="child.badge"
                class="badge badge-pill float-right"
                [ngClass]="{
              'badge-info mr-2': child.badge.type === 'badge-info',
              'badge-danger': child.badge.type === 'badge-danger'
            }">
            {{ child.badge.value }}
          </span>
        </a>

        <ul *ngIf="child.submenu" class="menu-content" [@popOverState]="child.isOpen">
          <li *ngFor="let subchild of child.submenu.items; trackBy: trackByMenu"
              class="isShown"
              [ngClass]="{
              'has-sub': subchild.submenu,
              'active': subchild.isSelected && !subchild.submenu,
              'open': subchild.isOpen && subchild.submenu
            }">
            <a class="menu-item"
               *ngIf="!subchild.submenu && !subchild.excludeInVertical"
               (click)="toggleMenu($event, subchild, true)"
               [routerLink]="subchild.page !== 'null' ? subchild.page : router.url">
              {{ subchild.title }}
            </a>

            <a class="menu-item"
               *ngIf="subchild.submenu && !subchild.excludeInVertical"
               (click)="toggleMenu($event, subchild, true)"
               [routerLink]="subchild.page !== 'null' ? subchild.page : router.url">
              {{ subchild.title }}
            </a>

            <ul *ngIf="subchild.submenu && !subchild.excludeInVertical" class="menu-content">
              <li *ngFor="let nestedChild of subchild.submenu.items; trackBy: trackByMenu"
                  [ngClass]="{ active: nestedChild.isSelected && !nestedChild.submenu }">
                <a class="menu-item"
                   [routerLink]="nestedChild.page"
                   (click)="toggleMenu($event, nestedChild, true)">
                  {{ nestedChild.title }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</aside>-->
<!--<aside class="sidebar" [class.open]="isOpen" aria-label="Billing navigation">

  <div class="sidebar-brand">
    <div class="brand-logo" aria-hidden="true">
      <img *ngIf="companyLogoUrl; else fallbackLogo" [src]="companyLogoUrl" [alt]="companyName + ' logo'" />
      <ng-template #fallbackLogo><span>🏨</span></ng-template>
    </div>
    <div class="brand-meta">
      <div class="brand-name">{{ companyName }}</div>
      <div class="brand-sub">{{ suiteName }}</div>
    </div>
    <button type="button"
            class="menu-refresh-btn"
            [class.loading]="menuLoading"
            [class.error]="menuError"
            (click)="refreshMenu()"
            aria-label="Refresh menu"
            title="Refresh menu">
      <span aria-hidden="true">↻</span>
    </button>
  </div>

  <nav class="sidebar-nav">
    <ng-container *ngFor="let section of navSections; trackBy: trackByNavSection">
      <div class="nav-section-label">{{ section.label }}</div>
      <a *ngFor="let item of section.items; trackBy: trackByNavItem"
         class="nav-item"
         href="javascript:void(0)"
         [class.active]="isNavItemActive(item)"
         (click)="onNavItem(item, $event)">
        <span class="nav-icon" aria-hidden="true">{{ emojiFor(item.iconKey) }}</span>
        <span class="nav-label">{{ item.label }}</span>
        <span *ngIf="item.badge" class="nav-badge">{{ item.badge }}</span>
      </a>
    </ng-container>
  </nav>
</aside>-->
<!--<aside class="sidebar" [class.open]="isOpen" aria-label="Billing navigation">

  <div class="sidebar-brand">
    <div class="brand-logo" aria-hidden="true">
      <img *ngIf="companyLogoUrl; else fallbackLogo" [src]="companyLogoUrl" [alt]="companyName + ' logo'" />
      <ng-template #fallbackLogo><span>🏨</span></ng-template>
    </div>
    <div class="brand-meta">
      <div class="brand-name">{{ company }}</div>-->
<!--<div class="brand-sub">{{ suiteName }}</div>-->
<!--</div>
    <button type="button"
            class="menu-refresh-btn"
            [class.loading]="menuLoading"
            [class.error]="menuError"
            (click)="refreshMenu()"
            aria-label="Refresh menu"
            title="Refresh menu">
      <span aria-hidden="true">↻</span>
    </button>
  </div>

  <nav class="sidebar-nav">
    <ng-container *ngFor="let section of navSections; trackBy: trackByNavSection">
      <div class="nav-section-label">{{ section.label }}</div>
      <a *ngFor="let item of section.items; trackBy: trackByNavItem"
         class="nav-item"
         href="javascript:void(0)"
         [class.active]="isNavItemActive(item)"
         (click)="onNavItem(item, $event)">
        <span class="nav-icon" aria-hidden="true">{{ emojiFor(item.iconKey) }}</span>
        <span class="nav-label">{{ item.label }}</span>
        <span *ngIf="item.badge" class="nav-badge">{{ item.badge }}</span>
      </a>
    </ng-container>
  </nav>
</aside>-->
<!--<div (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)" id="main-menu"
     class="main-menu menu-fixed menu-dark menu-accordion menu-shadow" data-scroll-to-active="true">
  <div id="main-menu-content" class="main-menu-content ps-container ps-theme-light" fxFlex="auto"
       [perfectScrollbar]="config">

    <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">-->
<!-- Menu -->
<!--{{child?child.title:''}}-->
<!--_menuSettingsConfig.vertical_menu.items , custommenu-->
<!--<li *ngFor="let child of custommenu" class="" [ngClass]="{
    'has-sub' : child.submenu,
    'nav-item' : child.title,
    'navigation-header' :child.section,
    'open' : child.isOpen && child.submenu,
    'active': child.isSelected && !child.submenu,
    'menu-collapsed-open': child.isSelected && child.submenu,
    'hover': child.hover
    }">-->
<!-- (click)="select('main', child.section)" 'active': isActive('main', child.section),'active': child.isSelected && !child.submenu,-->
<!-- Section -->
<!--<span class="menu-title" *ngIf="child.section">{{child.section}}</span>
<i class="la" *ngIf="child.section" [ngClass]="child.icon" data-toggle="tooltip" data-placement="right"
   data-original-title="Support"></i>-->
<!--<ul style="display:none;">-->
<!--<li class="nav-item" *ngFor="let subchild of child.submenu" [ngClass]="{active: isActive('sub', subchild.title)}" (click)="select('sub', subchild.title, $event);">-->
<!--<i class="la" [ngClass]="child.icon"></i>-->
<!--<span class="menu-title" data-i18n="">{{child.title}}</span>-->
<!--<a *ngIf="child.title && !child.submenu && !child.excludeInVertical && !child.isExternalLink && !child.issupportExternalLink && !child.isStarterkitExternalLink"
   routerLink="{{child.page !== 'null'?child.page:router.url}}" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>
<a *ngIf="child.title && !child.submenu && !child.excludeInVertical && child.isExternalLink"
   [href]="child.page" target="_blank" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>
<a *ngIf="child.title && !child.submenu && !child.excludeInVertical && child.isStarterkitExternalLink"
   [href]="child.page" target="_blank" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>-->
<!-- Submenu -->
<!--<a *ngIf="child.title && child.submenu && !child.excludeInVertical"
   routerLink="{{child.page !== 'null'?child.page:router.url}}" (click)="toggleMenu($event, child)">
  <i class="la" [ngClass]="child.icon"></i>
  <span class="menu-title" data-i18n="">{{child.title}}</span>
  <span *ngIf="child.badge" class="badge badge-pill float-right"
        [ngClass]="{'badge-info mr-2': child.badge.type==='badge-info' , 'badge-danger':child.badge.type==='badge-danger'}">
    {{child.badge.value}}
  </span>
</a>-->
<!--</li>-->
<!--</ul>-->
<!-- Root Menu -->
<!--<ul *ngIf="child.submenu" class="menu-content" [@popOverState]="child.isOpen">-->
<!-- Submenu of Submenu -->
<!--<li *ngFor="let subchild of child.submenu.items" class="isShown"
              [ngClass]="{'has-sub':(subchild.submenu),'active': subchild.isSelected && !subchild.submenu, 'open': subchild.isOpen && subchild.submenu}">
            <a class="menu-item" *ngIf="!subchild.submenu && !subchild.excludeInVertical" (click)="toggleMenu($event, subchild, true)"
               routerLink="{{subchild.page !== 'null'?subchild.page:router.url}}">{{subchild.title}}</a>
            <a class="menu-item" *ngIf="subchild.submenu && !subchild.excludeInVertical" (click)="toggleMenu($event, subchild, true)"
               routerLink="{{subchild.page !== 'null'?subchild.page:router.url}}">{{subchild.title}}</a>
            <ul *ngIf="subchild.submenu && !subchild.excludeInVertical" class="menu-content">
              <li *ngFor="let subchild of subchild.submenu.items" [ngClass]="{'active': subchild.isSelected && !subchild.submenu}">
                <a class="menu-item" *ngIf="!subchild.event"
                   routerLink="{{subchild.page}}" (click)="toggleMenu($event, subchild, true)">{{subchild.title}}</a>
                <a class="menu-item" *ngIf="subchild.event"
                   (click)="callFunction(subchild.event, subchild)">{{subchild.title}}</a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>-->



<div id="main-menu" class="main-menu menu-fixed menu-dark menu-accordion menu-shadow" [class.expanded]="isOpen">
  <div class="main-menu-content">
    <ul class="navigation navigation-main" [style.overflow]="'auto'">
      <ng-container *ngFor="let section of navSections; trackBy: trackByNavSection">
        <li class="nav-item has-sub" [ngClass]="{ open: isSectionOpen(section) }">
          <a href="javascript:void(0)" (click)="toggleSection(section)">
            <i class="feather ft-folder"></i>
            <span class="menu-title">{{ section.label }}</span>
          </a>
          <ul class="menu-content">
            <li *ngFor="let item of section.items; trackBy: trackByNavItem"
                [ngClass]="{ active: isNavItemActive(item) }">
              <a class="menu-item" href="javascript:void(0)" (click)="onNavItem(item, $event)">
                <i class="la" [ngClass]="iconClassFor(item.iconKey)"></i>
                <span class="menu-title">{{ item.label }}</span>
                <span *ngIf="item.badge" class="badge badge-pill badge-danger float-right mr-2">{{ item.badge }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </div>
</div>






